import { GatewayExportDocuments } from "@conformite/gateway";
import { userSession } from "@src/session/UserSession";

export class GatewayExportDocumentsApi {
  static async exportDocuments(
    type: GatewayExportDocuments.ExportDocumentType
  ) {
    return userSession.axiosInstance.get<ArrayBuffer>(
      `${GatewayExportDocuments.exportDocumentsUrl}/${type}`
    );
  }

  static async getSignedURL(type: GatewayExportDocuments.ExportDocumentType) {
    return userSession.axiosInstance.get<{
      url: string;
    }>(`${GatewayExportDocuments.signedUrlDocumentsUrl}/${type}`);
  }
}
